<template>
  <div>
    <div v-if="show" style="padding-left: 38px;"><span class="cirle">收</span> [收件地址]
      {{this.receive}}
    </div>
    <div>
      <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" :colon="false" style="float: right">
        <a-form-model-item label="单号">
          <a-select v-model="value" placeholder="请选择" @change="getData">
            <a-select-option
              v-for="item in options"
              :key="item"
              :label="item"
              :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div v-if="show" class="show-li" style="padding-left: 18px;">
      <ul style="margin: 0">
        <li>.</li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
    <a-timeline :reverse=true style="padding-left: 38px;">
      <a-timeline-item
        v-for="(activity, index) in activities"
        :key="index"
        :size="size"
        :timestamp="activity.AcceptTime">
        {{activity.AcceptStation}}
        <br/>
        {{ activity.AcceptTime}}
      </a-timeline-item>
    </a-timeline>
  </div>

</template>


<script>
import {timeLine} from '../api/order';

async function getData() {
  this.show = false;
  this.activities = [];
  const result = await timeLine({
    orderNo: this.value,
    expressCode: this.express,
    wmsNo: this.wmsHao,
    ifsNo: this.ifsNo
  });
  const { code, data: { traces } } = result;
  this.$emit('fatherMethod');
  if (traces && traces.length > 0) {
    this.activities = traces;
    this.show = true;
  } else {
    this.$message.error('暂无物流信息');
  }
}

export default {
  name: 'TimeLine',
  props: {
    orderId: String,
    wmsNo: String,
    ifsNo: String,
    expressCode: String,
    receiveAddress: String,
  },
  data() {
    return {
      options: [],
      value: '',
      id: '',
      express: '',
      wmsHao: '',
      receive: '',
      show: false,
      activities: [],
      size: 'large',
    };
  },
  created() {
    this.id = this.orderId;
    const split = this.id.split(',');
    if (split != undefined || split.length > 0) {
      this.options = split;
      this.value = split[0];
    }
    this.express = this.expressCode;
    this.wmsHao = this.wmsNo;
    this.receive = this.receiveAddress;
    this.getData();
  },
  watch: {
    orderId(val) {
      this.id = val;
      const split = this.id.split(',');
      if (split != undefined || split.length > 0) {
        this.options = split;
        this.value = split[0];
      }
      this.express = this.expressCode;
      this.receive = this.receiveAddress;
      this.wmsHao = this.wmsNo;
      this.getData();
    },
  },
  mounted() {
  },
  methods: {// 定义方法
    getData,
  },
};
</script>

<style scoped>
  .show-li li {
    color: rgb(238, 237, 231);
  }

  .cirle {
    color: rgb(201, 201, 201);
    width: 30px;
    height: 30px;
    font-size: 20px;
    border-radius: 4em;
    background: rgb(238, 237, 231);
  }

</style>
